import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const floatUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0) scale(0.8);
  }
  50% {
    opacity: 1;
    transform: translateY(-20px) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translateY(-40px) scale(0.8);
  }
`;

const HeartContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 1000;
`;

const AnimatedHeart = styled.div`
  font-size: 24px;
  color: #ff4757;
  animation: ${floatUp} 1s ease-out forwards;
  user-select: none;
`;

const HeartAnimation = ({ show, onComplete }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (show) {
      setIsVisible(true);
      
      // Hide after animation completes
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onComplete) {
          onComplete();
        }
      }, 1000); // Match animation duration
      
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);
  
  if (!isVisible) return null;
  
  return (
    <HeartContainer>
      <AnimatedHeart>❤️</AnimatedHeart>
    </HeartContainer>
  );
};

export default HeartAnimation;